import { render, staticRenderFns } from "./InviteAccept.vue?vue&type=template&id=b5462d60&scoped=true&"
import script from "./InviteAccept.vue?vue&type=script&lang=js&"
export * from "./InviteAccept.vue?vue&type=script&lang=js&"
import style0 from "./InviteAccept.vue?vue&type=style&index=0&id=b5462d60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5462d60",
  null
  
)

export default component.exports